import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Container, Row} from "react-bootstrap";
import FeatureCard from "./FeatureCard";
import './HomePage.css';
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import LocalDataService from "../../api/LocalDataService";
import LiveStreamPopup from "../../components/homePopup/homePopup";
import HomePopup from "../../components/homePopup/homePopup";
import { getCurrentDomainConfig } from "../../utils/domainConfig";

const backgroundImage = "/images/home/home_top_bg.png";
const features = [
    {
        icon: '/images/home/home_bottom_lable1.png',
        title: '视频合成',
        description: '可将视频素材、图片素材合成视频，支持BGM、配音、转场动画、贴纸等，人人都可一键成片',
    },
    {
        icon: '/images/home/home_bottom_lable2.png',
        title: '视频转音频',
        description: '可将视频中的音频提取出来，支持多种音频格式',
    },
    {
        icon: '/images/home/home_bottom_lable3.png',
        title: '图生视频',
        description: '包含豆包、海螺、vidu、万相、可灵即梦等图生视频',
    },
    {
        icon: '/images/home/home_bottom_lable4.png',
        title: '字幕音频对齐',
        description: '智能同步字幕与音频，精准校准时间轴，打造专业视听体验',
    },
    {
        icon: '/images/home/home_bottom_lable5.png',
        title: '声音克隆',
        description: '克隆声音，生成属于你的专属声音',
    },
    {
        icon: '/images/home/home_bottom_lable6.png',
        title: '视频搜索',
        description: '支持抖音、快手、小红书、B站等平台视频搜索，轻松获取创作素材',
    },
    {
        icon: '/images/home/home_bottom_lable7.png',
        title: '视频全平台下载',
        description: '支持抖音、快手、小红书、B站等平台视频资源下载，轻松获取创作素材',
    },
    {
        icon: '/images/home/home_bottom_lable8.png',
        title: '获取第三方平台数据',
        description: '链接各大平台数据源，可获取淘宝、京东、拼多多、抖音、快手、小红书、B站等平台数据，主力内容创作决策',
    },
    // 其他功能项...
];

const HomePage = ({userProfileRef}) => {
    const navigate = useNavigate();

    const [showLiveStreamPopup, setShowLiveStreamPopup] = React.useState(false);
    const handleNavLinkClick = (e) => {
            let user_info = LocalDataService.load_user_data();
            // 假设 LocalDataService 中有一个方法来检查用户是否已登录
            if (!user_info) {
                e.preventDefault(); // 阻止链接默认行为
                userProfileRef.current.showLoginModal(false);
                // 如果用户未登录，重定向到登录页面
            }
    };
    React.useEffect(() => {
        checkShowLiveStreamPopup();
    }, []);
    // 检查是否显示加群弹窗
    var checkShowLiveStreamPopup = function checkShowLiveStreamPopup() {
        // 检查今天是否已经点击过"今日不再提醒"
        var today = new Date().toISOString().split('T')[0];
        var dismissedDate = localStorage.getItem('livestream_popup_dismissed_date');
        if (dismissedDate === today) {
            // 今天已经点击过"今日不再提醒"
            return;
        }

        setShowLiveStreamPopup(true);
    };

    return (

        <div className="homepage" style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right top',
            backgroundColor: '#0a0e17',
        }}>
            <HomePopup onClose={() => setShowLiveStreamPopup(false)} isVisible={showLiveStreamPopup}/>
            {/* Header Section */}
            <header className="homepage-header">
                <h1><span style={{color: '#FFF'}}>体验{getCurrentDomainConfig().siteName}</span> {getCurrentDomainConfig().siteDescription}</h1>
                <p>
                    <span>一键将AI生成的视频内容导入剪映，快速完成剪辑与合成，</span>
                    <br/>
                    <span>支持本地草稿与云端MP4</span>
                </p>
                <a href={'/cozeList'} role={'button'} className={'btn home-btn-primary'}
                   onClick={(e) => handleNavLinkClick(e)}>
                    立即体验
                </a>

            </header>

            <Container className={'mt-5'}>
                {/* Main Content Section */}
                <main className="homepage-main ">

                    <div className="function-item">
                        {/* 左侧内容 */}
                        <div className="homepage-left">
                            {/* 智能体中草稿链接 */}
                            <img src="/images/home/home_func_guide_1.png" alt=""
                                 style={{width: '100%', height: 'auto',}}/>
                        </div>


                        {/* 右侧内容 */}
                        <div className="homepage-right">
                            {/* 剪映草稿大师 */}
                            <section className="function-black" style={{position: 'relative',}}>
                                <h3>剪映草稿大师</h3>
                                <div className="function-black-items">
                                    <div className="function-black-item">
                                        <div className="tag">
                                            <img src="/images/home/home_lable1.png" width="73" alt="剪映小助手"/>
                                            <span>云端渲染</span>
                                        </div>
                                        <p>一键将AI生成的视频内容导入剪映，快速完成剪辑与合成，支持本地草稿与云端MP4。 </p>
                                    </div>
                                    <div className="function-black-item">
                                        <div className="tag">
                                            <img src="/images/home/home_lable2.png" width="43" alt="剪映小助手"/>
                                            <span>智能合成</span>
                                        </div>
                                    </div>
                                    <div className="function-black-item">
                                        <div className="tag">
                                            <img src="/images/home/home_lable3.png" width="43" alt="剪映小助手"/>
                                            <span>极速导入</span>
                                        </div>
                                    </div>
                                </div>
                                <button className="btn home-btn-secondary"
                                        onClick={() => navigate('/JianYingAssistant')}>立即体验
                                </button>
                            </section>
                        </div>
                    </div>


                    <div className="function-item">
                        {/* 左侧内容 */}
                        <div className="homepage-left">
                            {/* 智能体中草稿链接 */}
                            <img src="/images/home/home_func_guide_2.png" alt=""
                                 style={{width: '100%', height: 'auto',}}/>
                        </div>

                        {/* 右侧内容 */}
                        <div className="homepage-right">
                            {/* 课程学堂 */}
                            <section className="function-black" style={{position: 'relative',}}>
                                <h3>课程学堂</h3>
                                <div className="function-black-items">
                                    <div className="function-black-item">
                                        <div className="tag">
                                            <img src="/images/home/home_lable4.png" width="33" alt="课程学堂"/>
                                            <span>零基础入门</span>
                                        </div>
                                        <p>从入门到精通，一站式AI智能体创建与管理学习平台。</p>
                                    </div>
                                    <div className="function-black-item">
                                        <div className="tag">
                                            <img src="/images/home/home_lable5.png" width="30" alt="课程学堂"/>
                                            <span>实用案例</span>
                                        </div>
                                    </div>
                                    <div className="function-black-item">
                                        <div className="tag">
                                            <img src="/images/home/home_lable6.png" width="39" alt="课程学堂"/>
                                            <span>快速上手</span>
                                        </div>
                                    </div>
                                </div>
                                <a href={"/courseList"} role={"button"}  className="btn home-btn-secondary"
                                   onClick={(e) => {}}>立即体验
                                </a>
                            </section>
                        </div>
                    </div>


                    <div className="function-item">
                        {/* 左侧内容 */}
                        <div className="homepage-left">
                            {/* 海量插件 */}
                            <section className="function-black" style={{position: 'relative',}}>
                                <h3>海量插件</h3>
                                <div className="function-black-items">
                                    <div className="function-black-item">
                                        <div className="tag">
                                            <img src="/images/home/home_lable7.png" width="76" alt="海量插件"/>
                                            <span>视频合成 / 声音克隆</span>
                                        </div>
                                        <p>提供丰富多样的高效能插件，包含视频合成、视频转音频、全平台视频下载、图生视频、声音克隆、
                                            获取第三方平台数据等插件。</p>
                                    </div>
                                    <div className="function-black-item">
                                        <div className="tag">
                                            <img src="/images/home/home_lable8.png" width="30" alt="海量插件"/>
                                            <span>平台数据获取</span>
                                        </div>
                                    </div>
                                </div>
                                <button className="btn home-btn-secondary"
                                        onClick={() => window.open("https://www.coze.cn/user/3076900288473971")}>立即体验
                                </button>
                            </section>
                        </div>

                        {/* 右侧内容 */}
                        <div className="homepage-right">
                            {/* 海量插件 */}
                            <img src="/images/home/home_func_guide_3.png" alt=""
                                 style={{width: '100%', height: 'auto',}}/>
                        </div>
                    </div>

                    <div className="function-item">
                        {/* 左侧内容 */}
                        <div className="homepage-left">
                            {/* 爆款工作流 */}
                            <section className="function-black" style={{position: 'relative',}}>
                                <h3>爆款工作流</h3>
                                <div className="function-black-items">
                                    <div className="function-black-item">
                                        <div className="tag">
                                            <img src="/images/home/home_lable9.png" width="34" alt="爆款工作流"/>
                                            <span>热门智能体模板</span>
                                        </div>
                                        <p>爆款视频智能体快捷制作，跳过复杂搭建，直接使用专业级AI工作流</p>
                                    </div>
                                    <div className="function-black-item">
                                        <div className="tag">
                                            <img src="/images/home/home_lable10.png" width="45" alt="爆款工作流"/>
                                            <span>持续更新</span>
                                        </div>
                                    </div>
                                    <div className="function-black-item">
                                        <div className="tag">
                                            <img src="/images/home/home_lable11.png" width="34" alt="爆款工作流"/>
                                            <span>海量工作流</span>
                                        </div>
                                    </div>
                                </div>
                                <a href={'/cozeList'} role={'button'} className="btn home-btn-secondary"
                                   onClick={(e) => handleNavLinkClick(e)}>立即体验
                                </a>
                            </section>
                        </div>

                        {/* 右侧内容 */}
                        <div className="homepage-right">
                            {/* 爆款工作流 */}
                            <img src="/images/home/home_func_guide_4.png" alt=""
                                 style={{width: '100%', height: 'auto',}}/>
                        </div>
                    </div>

                    <div className="function-item">
                        {/* 左侧内容 */}
                        <div className="homepage-left">
                            {/* 推广赚钱 */}
                            <section className="function-black" style={{position: 'relative',}}>
                                <h3>推广赚钱</h3>
                                <div className="function-black-items">
                                    <div className="function-black-item">
                                        <div className="tag">
                                            <img src="/images/home/home_lable12.png" width="34" alt="推广赚钱"/>
                                            <span>高额佣金</span>
                                        </div>
                                        <p>提供丰富多样的高效能插件，包含视频合成、视频转音频、全平台视频下载、图生视频、声音克隆、
                                            获取第三方平台数据等插件。</p>
                                    </div>
                                    <div className="function-black-item">
                                        <div className="tag">
                                            <img src="/images/home/home_lable13.png" width="35" alt="推广赚钱"/>
                                            <span>官方授权</span>
                                        </div>
                                    </div>
                                    <div className="function-black-item">
                                        <div className="tag">
                                            <img src="/images/home/home_lable14.png" width="36" alt="推广赚钱"/>
                                            <span>被动收入</span>
                                        </div>
                                    </div>
                                </div>
                                <a  href={'/promotion'} role={'button'} className="btn home-btn-secondary" onClick={(e) => handleNavLinkClick(e)}>立即体验
                                </a>
                            </section>
                        </div>

                        {/* 右侧内容 */}
                        <div className="homepage-right">
                            {/* 爆款工作流 */}
                            <img src="/images/home/home_func_guide_5.png" alt=""
                                 style={{width: '100%', height: 'auto',}}/>
                        </div>
                    </div>

                    <h2>海量插件和工作流</h2>
                    <div style={{
                        backgroundColor: '#A32EE3',
                        width: "86px",
                        height: "6px",
                        opacity: 1,
                        display: 'block',
                        margin: '17px auto'
                    }}/>
                    <p style={{color: '#C7B2D2'}}>100+核心插件，50+智能体，每日持续更新中，更多玩法敬请期待</p>
                    <Row className="justify-content-center">
                        {features.map((feature, index) => (
                            <FeatureCard key={index} {...feature} />
                        ))}
                    </Row>

                </main>


            </Container>


            {/* Footer Section */}
            <footer className="homepage-footer">
                <div className="footer-content">
                    <div className='footer-logo'>
                        <img src="/images/logo.svg" width={76} alt='沸推AI' style={{marginRight: '18px'}}></img>
                        <span style={{color: '#02C8E3', fontSize: '43px', alignSelf: 'center'}}>
                            {getCurrentDomainConfig().siteName}
                        </span>
                    </div>
                    <div className='footer-info'>
                        <p>备案号：<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer">{getCurrentDomainConfig().icpNumber}</a></p>
                        <p>{getCurrentDomainConfig().copyrightText}</p>
                    </div>
                </div>
            </footer>

        </div>
    );
};

export default HomePage;
